import { useState } from 'react';
import { ContactContainer, Hero, ContactSection, ContactInfo, ContactForm } from './styles';
import { Button } from '../../components/Button';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import axios from 'axios';
import { BASE_API_URL_ENDPOINT } from '../../api/Api';
import toast, { Toaster } from "react-hot-toast";



const Contact = () => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    const form = e.target;
    const data = {
      name: form.name.value,
      email: form.email.value,
      subject: form.subject.value,
      message: form.message.value,
    };

    try {
      const res = await axios.post(`${BASE_API_URL_ENDPOINT}process/mail/send`, data);
      if (res.data.success) {
        toast.success(res.data.message);
        form.reset();
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Une erreur s'est produite lors de l'envoi du message.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContactContainer>
      <Hero>
        <h1>Contactez-nous</h1>
        <p>Nous sommes à votre écoute</p>
      </Hero>

      <ContactSection className="container">
        <ContactInfo>
          <h2>Informations de contact</h2>
          <p>N'hésitez pas à nous contacter pour toute question ou collaboration.</p>

          <div className="info-item">
            <FaPhone />
            <div>
              <h3>Téléphone</h3>
              <p>+243 998 211 469</p>
              <p>+243 816 869 438</p>
              <p>+243 998 187 483</p>
            </div>
          </div>

          <div className="info-item">
            <FaEnvelope />
            <div>
              <h3>Email</h3>
              <p>contact@codhod.org</p>
            </div>
          </div>

          <div className="info-item">
            <FaMapMarkerAlt />
            <div>
              <h3>Adresse</h3>
              <p>79 AV/Kalembelembe Q/Aketi C/Kinshasa<br />Kinshasa, RDC</p>
            </div>
          </div>
        </ContactInfo>

        <ContactForm onSubmit={handleSubmit}>
          <h2>Envoyez-nous un message</h2>

          <div className="form-group">
            <label htmlFor="name">Nom complet</label>
            <input type="text" id="name" name="name" required />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" name="email" required />
          </div>

          <div className="form-group">
            <label htmlFor="subject">Sujet</label>
            <input type="text" id="subject" name="subject" required />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea id="message" rows="5" name="message" required></textarea>
          </div>

          <Toaster position="top-center" reverseOrder={false} />

          {loading ? (
            <Button disabled>Envoi en cours...</Button>
          ) : (
            <Button $primary type="submit">Envoyer le message</Button>
          )}
        </ContactForm>
      </ContactSection>
    </ContactContainer>
  )
};

export default Contact;